import styled from 'styled-components';

export const OrderedList = styled.ol`
  margin-left: var(--spacing-x-large, 32px);
`;

export const ListItem = styled.li`
  margin-bottom: 12px;
`;
